import React, {Component} from "react";  import config from 'react-global-configuration';
import msparcs from "assets/img/msparcs.png";


class WelcomePage extends Component {
    state = {
        data: [],
        chartHeight:"250px",
    };
    componentWillMount(){
      
    }

  
    render() {
        return (
            <div className = "content">
                <div className="container-fluid space-container-fluid">
                    <div className = "row">
                        <div className="col-md-6 col-md-offset-3">
                            <div className="card p-10">
                                <div className="header text-center">
                                   <h2 className="title">
                                        <img src={msparcs} alt={msparcs} className="mSpaceLogo" width={'50%'} />
                                        <br/>
                                        Welcome To Sparcs
                                    </h2>
                                    <p className="category">
                                        <strong> Innoviti’s Analytics Platform </strong>
                                    </p>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );

    }


}
export default WelcomePage;